document.addEventListener("DOMContentLoaded", function(){

    const header = document.querySelector(".sticky-header");

    if(!header) return;

    window.addEventListener("scroll", function(){

        if(window.scrollY > 30){

            header.classList.add("scrolled");

        }else{

            header.classList.remove("scrolled");

        }

    });

});